import React, { useState, useEffect, Fragment } from "react";
import {
  Row,
  Col,
  CardBody,
  Input,
  Table,
  Card,
  UncontrolledTooltip
} from "reactstrap";
import { 
  getUsersAdminRolesList,
  postUsersAdminCreate,
  patchUsersAdminPermissions,
  patchUsersAdminRoles, 
  getUsersAdminPermissionsList,
  getUsersAdminPermissionsRoleList
} from "../../../helpers/api_rombo_helper";
import i18n from "../../../i18n";
import { useDispatch } from "react-redux";
import Select from "react-select";
import { map } from "lodash";
import Spinners from "../../../components/Common/Spinner";
import { useNavigate } from 'react-router-dom';
import Paginations from "../../../components/Common/Pagination";
import StyledPagination from "../../../components/Common/StyledPagination";

const Step2 = ({ step, setStep, name, phone, email, token, lastName, secondLastName, company, isRole, setInfoUser, infoUser, setErrorAlert, setErrorAlertMessage }) => {

  const dispatch = useDispatch()
  const history = useNavigate();
  const [listRoles, setListRoles] = useState()
  const [isLoading, setLoading] = useState(true)
  const [roles, setRoles] = useState([])
  const [selectedRol, setSelectedRol] = useState(null);
  const [permissions, setPermissions] = useState({});
  const [fPermissions, setFPermissions] = useState([]);
  const [listPermissions, setListPermissions] = useState([]);
  const [fListPermissions, setFListPermissions] = useState({});
  const [opts, setOpts] = useState({});
  const [opts2, setOpts2] = useState({});
  const [filterDescription, setFilterDescription] = useState(null);
  const [filterRolName, setFilterRolName] = useState(null);
  const [idRoles, setIdRoles] = useState([])
  const [buttonSearch1, setButtonSearch1] = useState(true)
  const [buttonSearch2, setButtonSearch2] = useState(true)
  const [currentPage, setCurrentPage] = useState(1);
  const [recordsPerPage] = useState(7);
  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
  const currentRecords = fPermissions.slice(indexOfFirstRecord, indexOfLastRecord);
  const nPages = Math.ceil(fPermissions.length / recordsPerPage)

  useEffect(() => {
    onGetUsersAdminRolesList()
    onGetUsersAdminPermissionsList()
  }, [dispatch]);

  const onGetUsersAdminRolesList = () => {
    let arr = []
    getUsersAdminRolesList(token)
      .then((reponse) => {
        map(reponse, (item, key) => (
          arr.push({ value: item.id, label: item.description })
        ))
        setListRoles([...arr])
      })
  }
  
  const onGetUsersAdminPermissionsList = (newOpts = { page: 1, size: 7 }) => {
    let arr = []
    getUsersAdminPermissionsList(token, newOpts)
      .then((response) => {
        setListPermissions(response)
        setFListPermissions(response.items)
        setOpts(newOpts)
      })
      .catch((error) => {
        console.error("Error - getUsersAdminPermissionsList - ", error)
      })
  }

  const onGetUsersAdminPermissionsRoleList = (id, newOpts = { page: 1, size: 50 }, findRole = {}) => {
    let arr = [];
    setPermissions(arr);
    getUsersAdminPermissionsRoleList(token, id, newOpts)
      .then((response) => {
        let arr = fPermissions;
        response.items.map((item) => {
          fPermissions.filter((itemP) => itemP.name == item.name).shift() ? null : arr.push({ ...item, rol_id: (findRole.value || selectedRol.value), rol_name: (findRole.label || selectedRol.label)})
        })
        response.items = arr
        setPermissions(response)
        setFPermissions([...arr])
      })
      .catch((error) => {
        console.error("Error - getUsersAdminPermissionsRoleList - ", error)
      })
  }

  const onBackNextStep = () => {
    setStep(step - 1);
  }

  const onClickAddRol = () => {
    if(!selectedRol.value) return;

    let onListRoles = listRoles
    let onRoles = roles
    let arrRoles = idRoles
    onRoles.push(selectedRol)
    arrRoles.push(selectedRol.value)
    let findRole = onListRoles.filter((item) => {
      return item.value == selectedRol.value
    }).shift()
    onListRoles.splice(onListRoles.indexOf(findRole), 1)
    setListRoles([...onListRoles])
    setIdRoles([...arrRoles])
    setRoles([...onRoles]);
    onGetUsersAdminPermissionsRoleList(selectedRol.value, { size: 200, page: 1 }, selectedRol.value);
    setSelectedRol(null); 
  }
  
  const onClickRemovePermission = (e) => {
    let arr = fPermissions
    let findPermission = fPermissions.filter(function(opt) {
      return opt.name === e.name
    }).shift();
    if(findPermission){
      arr.splice(arr.indexOf(findPermission), 1)
      setFPermissions([...arr])
    }
  }
  
  const onClickAddPermission = (e) => {
    let arr = fPermissions
    arr.push({ ...e, individual: true })
    setFPermissions([...arr])
  }

  const onClickFilterList = (type = null) => {
    let arr = []
    buttonSearch1 ? (setFilterDescription("")) : null
    buttonSearch2 ? (setFilterRolName("")) : null
    buttonSearch1 ? document.getElementById(`${type == 'init' ? "filter1Name" : "filter2Name"}`).value = null : null
    buttonSearch2 ? document.getElementById(`${type == 'init' ? "filter1Rol" : "filter2Rol"}`).value = null : null
    fPermissions.map((item) => (item.description == filterDescription || item.rol_name == filterRolName) && arr.push(item) )
    type == "init" ? setButtonSearch1(!buttonSearch1) : setButtonSearch2(!buttonSearch2)
    type == "init" ?
      onGetUsersAdminPermissionsList({ page: 1, size: 10, description: filterDescription, rol_name: filterRolName }) :
        (arr.length == 0 ? setRolPermissions() : setFPermissions([...arr]))
  }

  const setRolPermissions = () => {
    roles.map((rol) => {
      setSelectedRol(rol)
      onGetUsersAdminPermissionsRoleList(rol.value, { size: 200, page: 1 }, rol)
    })
  }

  const removeRole = (rol) => {
    let arr = roles
    let arrRoles = idRoles
    let onFPermissions = fPermissions
    let onListRoles = listRoles
    let findRole = roles.filter(function(opt) {
      return opt.value === rol.value
    }).shift();
    if(findRole){
      permissions.items.map((per) => {
        if(findRole.value == per.rol_id){
          onFPermissions.splice(onFPermissions.indexOf(per), 1)
          setFPermissions([...onFPermissions])
        }
      })
      onListRoles.push(findRole)
      setListRoles([...onListRoles])
      arrRoles.splice(arrRoles.indexOf(findRole.value), 1)
      setIdRoles(arrRoles)
      arr.splice(arr.indexOf(findRole), 1)
      setRoles([...arr]) 
    }
  }

  const onClickSave = async () => {
    let onPermissions = [];
    fPermissions.map((item) => item.individual && onPermissions.push(item.name));
  
    let body = {
      full_name: name,
      email: email,
      phone: phone,
      partner_name: company.label,
      is_staff: isRole === "STAFF",
      is_customer_admin: isRole === "ADMIN",
      is_customer_user: isRole === "USER",
    };
  
    if (infoUser.is_staff) {
      body.partner_id = String(company.value);
    }

    const missingFields = [];
    if (!name) missingFields.push(i18n.t("UserName"));
    if (!email) missingFields.push(i18n.t("UserEmail"));
    if (!phone) missingFields.push(i18n.t("UserPhone"));
    if (!roles || roles.length === 0) missingFields.push(i18n.t("AssignedRoles"));

    if (missingFields.length > 0) {
      const errorMessage = `${i18n.t("PleaseFillAllFields")}: ${missingFields.join(", ")}`;
      console.error(i18n.t("PleaseFillAllFields"), missingFields);
      setErrorAlertMessage(errorMessage);
      setErrorAlert(true);
      return;
    }

    postUsersAdminCreate(token, body)
      .then((user) => {
        if (user.id) {
          if (roles.length !== 0) {
            patchUsersAdminRoles(
              token,
              user.id,
              { ids: roles.map((item) => item.value) },
              { params: { type: "ADD" } }
            )
              .then((r_roles) => {
                const names = JSON.stringify(roles.map((opt) => opt.label));
                localStorage.setItem("notify", "true");
                localStorage.setItem("headerText", i18n.t("CreatedUser"));
                localStorage.setItem(
                  "bodyText",
                  i18n.t("SuccessCreatedUser", { rol_name: names })
                );
  
                if (onPermissions.length !== 0) {
                  patchUsersAdminPermissions(
                    token,
                    user.id,
                    { permissions: onPermissions },
                    { params: { type: "ADD" } }
                  )
                    .then(() => history("/users"))
                    .catch((error) =>
                      console.error("Error - patchUsersAdminPermissions -", error)
                    );
                } else {
                  history("/users");
                }
              })
              .catch((error) => {
                console.error("Error - patchUsersAdminRoles:", error);
                setErrorAlertMessage(
                  JSON.stringify(error.response?.data?.detail) || error.message
                );
                if (error.code === 500) {
                  setErrorAlertMessage(i18n.t("ServerError"));
                }
                setErrorAlert(true);
              });
          } else {
            history("/users");
          }
        }
      })
      .catch((error) => {
        console.error("Error - postUsersAdminCreate:", error);
        setErrorAlertMessage(
          JSON.stringify(error.response?.data?.detail) || error.message
        );
        if (error.code === 500) {
          setErrorAlertMessage(i18n.t("ServerError"));
        }
        setErrorAlert(true);
      });
  };  

  return (
    <Fragment>
      <CardBody>
        <h6 className="employees-form-title" htmlFor="companyNameInput">{i18n.t("RolUser", { name, lastName })}</h6>
        <p className="employees-form-text">{i18n.t("DescUserRol")}</p>
        <Col xs={11} xxl={6} xl={6} className="pt-2">
          <Col xs={12} xxl={12} xl={12} className="pt-2 row">
            <Col xs={10} xxl={10} xl={10} className="">
              <Card>
                <Select
                  name="rol"
                  value={selectedRol}
                  id="roles"
                  placeholder={i18n.t("SelectRole")}
                  options={listRoles}
                  className="select2-selection"
                  onChange={(e) => setSelectedRol(e)}
                />
              </Card>
            </Col>
            <Col xs={2} xxl={2} xl={2} className="">
              <button
                className="btn btn-users"
                disabled={selectedRol?.value == null}
                onClick={() => onClickAddRol()}>
                  {i18n.t("Add")}
              </button>
            </Col>
          </Col>
          {
            map(roles, (rol, key) => (
              <Col xs={12} xxl={5} xl={4} className="rounded-5 text-white p-1 bg-users mb-1">
                <i onClick={() => removeRole(rol)} className="bx bx-x-circle mx-1"></i>
                {rol.description || rol.label}
              </Col>
            ))
          }
        </Col>
        <Row>
          <Col xxl={6} md={6} xs={12}>
            <div className="table-responsive pt-3">
              <Col xxl={12} md={12} xs={12} className="pt-2 pb-2 bg-light d-flex text-center">
                <Col xxl={5} md={5} xs={1} className=""></Col>
                <Col xxl={7} md={7} xs={10} className="row">
                  <Col xxl={5} md={5} xs={5} className="">
                    <Input
                      id="filter1Name"
                      className="form-control search-box me-2 mb-2 d-inline-block fs-10"
                      placeholder={i18n.t("Name")}
                      disabled={!buttonSearch1}
                      onChange={(e) => setFilterDescription(e.target.value)}
                    />
                  </Col>
                  <Col xxl={5} md={5} xs={5} className="">
                    <Input
                      id="filter1Rol"
                      className="form-control search-box me-2 mb-2 d-inline-block fs-10"
                      placeholder={i18n.t("Category")}
                      disabled={!buttonSearch1}
                      onChange={(e) => setFilterRolName(e.target.value)}
                    />
                  </Col>
                  <Col xxl={2} md={2} xs={2} className="m-0 p-0">
                    <button className="btn btn-users fs-10" onClick={() => onClickFilterList("init")}>
                      {i18n.t(`${buttonSearch1 ? 'Search' : 'Clean'}`)}
                    </button>
                  </Col>
                </Col>
              </Col>
              <Table className="table table-responsive border">
                <thead>
                  <tr>
                    <th className="bg-light">{i18n.t("Name")}</th>
                    <th className="bg-light">{i18n.t("Category")}</th>
                    <th className="bg-light">{i18n.t("Actions")}</th>
                  </tr>
                </thead>
                {
                  isLoading ? null :
                    <tbody>
                      {map(fListPermissions, (permission, key) => (
                        <tr key={key}>
                          <td>{permission.description}</td>
                          <td>{permission.rol_name}</td>
                          <td>
                          <div className="d-flex gap-3">
                            {fPermissions.filter((item) => item.name == permission.name).shift() ? (
                              null
                            ) : (
                              <button
                                className="btn btn-users fs-8"
                                onClick={() => onClickAddPermission(permission)}>
                                  {i18n.t("Add")}
                              </button>
                            )}
                          </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                }
              </Table>
              {isLoading ? (
                <Spinners setLoading={setLoading} />
              ) : (
                <StyledPagination
                  setLoading={setLoading}
                  viewPaginations={5}
                  token={token}
                  opts={opts}
                  listTable={setFListPermissions}
                  methodCustom={getUsersAdminPermissionsList}
                  id={null} pages={listPermissions.pages}
                  page={listPermissions.page}
                  total={listPermissions.total}
                  size={listPermissions.size}
                  paginationDiv="col-lg-12"
                  paginationClass="pagination pagination-rounded justify-content-end mt-3 mb-4 pb-1"
                />
              )}
            </div>
          </Col>
          <Col xxl={6} md={6} xs={12}>
            <div className="table-responsive pt-3">
              <Col xxl={12} md={12} xs={12} className="pt-2 pb-2 bg-light d-flex text-center">
                <Col xxl={5} md={5} xs={1} className=""></Col>
                <Col xxl={7} md={7} xs={10} className="row">
                  <Col xxl={5} md={5} xs={5} className="">
                    <Input
                      id="filter2Name"
                      className="form-control search-box me-2 mb-2 d-inline-block fs-10"
                      placeholder={i18n.t("Name")}
                      disabled={!buttonSearch2}
                      onChange={(e) => setFilterDescription(e.target.value)}
                    />
                  </Col>
                  <Col xxl={5} md={5} xs={5} className="">
                    <Input
                      id="filter2Rol"
                      className="form-control search-box me-2 mb-2 d-inline-block fs-10"
                      placeholder={i18n.t("Category")}
                      disabled={!buttonSearch2}
                      onChange={(e) => setFilterRolName(e.target.value)}
                    />
                  </Col>
                  <Col xxl={2} md={2} xs={2} className="m-0 p-0">
                    <button className="btn btn-users fs-10" onClick={() => onClickFilterList()}>
                      {i18n.t(`${buttonSearch2 ? 'Search' : 'Clean'}`)}
                    </button>
                  </Col>
                </Col>
              </Col>
              <Table className="table table-responsive border">
                <thead>
                  <tr>
                    <th className="bg-light">{i18n.t("Name")}</th>
                    <th className="bg-light">{i18n.t("Category")}</th>
                    <th className="bg-light">{i18n.t("Actions")}</th>
                  </tr>
                </thead>
                {
                  isLoading ? null :
                    <tbody>
                      {map(currentRecords, (permission, key) => (
                        <tr key={key}>
                          <td>{permission.description}</td>
                          <td>{permission.rol_name}</td>
                          <td className="text-center">
                            {idRoles.includes(permission.rol_id) ? null : (
                              <div className="d-flex justify-content-center gap-3">
                                <a
                                  className="text-danger"
                                  onClick={() => onClickRemovePermission(permission)}
                                >
                                  <i className="mdi mdi-delete font-size-18" id="addtooltip" />
                                  <UncontrolledTooltip placement="top" target="addtooltip">
                                    {i18n.t("Delete")}
                                  </UncontrolledTooltip>
                                </a>
                              </div>
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                }
              </Table>
              {isLoading ? (
                <Spinners setLoading={setLoading} />
              ) : (
                <Paginations
                  perPageData={recordsPerPage}
                  data={fPermissions}
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                  isShowingPageLength={false}
                  paginationDiv="col-lg-12"
                  paginationClass="pagination pagination-rounded justify-content-end mt-3 mb-4 pb-1"
                />
              )}
            </div>
          </Col>
          <Col xxl={12} md={12} xs={12} className="pt-3 d-flex">
            <button onClick={() => onClickSave()} className="btn btn-request">
              {i18n.t("UserCreate")}
            </button>
            <button onClick={() => onBackNextStep()} className="btn btn-go-back button-margin-minleft  border fs-11">
              {i18n.t("Back")}
            </button>
          </Col>
        </Row>
      </CardBody>
    </Fragment>
  )
}

export default Step2;
